import React from 'react';
import { ChevronLeft, Receipt, Download, Eye } from 'lucide-react';

const MOCK_INVOICE_RECORDS = [
  {
    id: 'INV202502001',
    date: '2025-02-20',
    buyer: '马钢诚兴马鞍山基地',
    amount: 28500.00,
    taxRate: 0.03,
    taxAmount: 855.00,
    totalAmount: 29355.00,
    status: '已开票'
  },
  {
    id: 'INV202502002',
    date: '2025-02-18',
    buyer: '慈湖基地',
    amount: 15600.00,
    taxRate: 0.03,
    taxAmount: 468.00,
    totalAmount: 16068.00,
    status: '已开票'
  },
  {
    id: 'INV202501015',
    date: '2025-01-28',
    buyer: '马钢诚兴马鞍山基地',
    amount: 42300.00,
    taxRate: 0.03,
    taxAmount: 1269.00,
    totalAmount: 43569.00,
    status: '已开票'
  },
  {
    id: 'INV202501008',
    date: '2025-01-15',
    buyer: '雨山基地',
    amount: 18500.00,
    taxRate: 0.03,
    taxAmount: 555.00,
    totalAmount: 19055.00,
    status: '已开票'
  },
  {
    id: 'INV202501003',
    date: '2025-01-08',
    buyer: '马钢诚兴马鞍山基地',
    amount: 31200.00,
    taxRate: 0.03,
    taxAmount: 936.00,
    totalAmount: 32136.00,
    status: '已开票'
  }
];

export default function InvoiceRecordsPage({ onBack }) {
  const formatMoney = (value) => {
    return value.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  return (
    <div className="min-h-full bg-slate-50">
      <div className="bg-gradient-to-br from-blue-500 via-blue-600 to-blue-700 text-white p-4 pt-12 pb-6">
        <div className="flex items-center gap-3 mb-4">
          <button onClick={onBack} className="p-1">
            <ChevronLeft size={24} />
          </button>
          <h1 className="text-lg font-bold">反向开票记录</h1>
        </div>
        
        <div className="bg-white/20 backdrop-blur-sm rounded-xl p-4 border border-white/30">
          <div className="flex justify-between items-center">
            <div>
              <div className="text-white/70 text-xs mb-1">今年累计开票金额</div>
              <div className="text-2xl font-bold">¥ 685,000.00</div>
            </div>
            <div className="text-right">
              <div className="text-white/70 text-xs mb-1">开票笔数</div>
              <div className="text-2xl font-bold">28 笔</div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-4 space-y-3">
        {MOCK_INVOICE_RECORDS.map((record) => (
          <div key={record.id} className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="p-4">
              <div className="flex justify-between items-start mb-3">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
                    <Receipt size={16} className="text-blue-600" />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-slate-800">{record.buyer}</div>
                    <div className="text-xs text-slate-400">{record.date}</div>
                  </div>
                </div>
                <span className="text-xs text-green-600 bg-green-50 px-2 py-1 rounded-full font-medium">
                  {record.status}
                </span>
              </div>
              
              <div className="bg-slate-50 rounded-lg p-3 space-y-2">
                <div className="flex justify-between text-xs">
                  <span className="text-slate-500">发票号码</span>
                  <span className="text-slate-700 font-mono">{record.id}</span>
                </div>
                <div className="flex justify-between text-xs">
                  <span className="text-slate-500">未税金额</span>
                  <span className="text-slate-700">¥ {formatMoney(record.amount)}</span>
                </div>
                <div className="flex justify-between text-xs">
                  <span className="text-slate-500">税率/税额</span>
                  <span className="text-slate-700">{(record.taxRate * 100).toFixed(0)}% / ¥ {formatMoney(record.taxAmount)}</span>
                </div>
                <div className="h-px bg-slate-200 my-1" />
                <div className="flex justify-between text-sm">
                  <span className="text-slate-600 font-medium">价税合计</span>
                  <span className="text-red-500 font-bold">¥ {formatMoney(record.totalAmount)}</span>
                </div>
              </div>
            </div>
            
            <div className="flex border-t border-slate-100">
              <button className="flex-1 py-3 text-sm text-slate-600 flex items-center justify-center gap-1.5 hover:bg-slate-50 transition-colors">
                <Eye size={14} />
                查看发票
              </button>
              <div className="w-px bg-slate-100" />
              <button className="flex-1 py-3 text-sm text-blue-600 flex items-center justify-center gap-1.5 hover:bg-blue-50 transition-colors">
                <Download size={14} />
                下载
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
